import { initializeApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";
import { getStorage, type FirebaseStorage } from "firebase/storage";

/**
 * Inicializar Firebase
 * @constant {App} app - Aplicación de Firebase
 */
const app = initializeApp({
  apiKey: (import.meta.env.VITE_FIREBASE_API_KEY as string | undefined) ?? "tu-api-key",
  authDomain:
    (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined) ??
    "tu-proyecto.firebaseapp.com",
  projectId:
    (import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined) ?? "tu-proyecto-id",
  storageBucket:
    (import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string | undefined) ??
    "tu-proyecto.appspot.com",
  messagingSenderId:
    (import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined) ??
    "123456789",
  appId: (import.meta.env.VITE_FIREBASE_APP_ID as string | undefined) ?? "tu-app-id",
});

/**
 * Autenticación de Firebase
 * @constant {Auth} auth - Autenticación de Firebase
 */
export const auth: Auth = getAuth(app);

/**
 * Base de datos de Firebase
 * @constant {Firestore} db - Base de datos de Firebase
 */
export const db: Firestore = getFirestore(app);

/**
 * Almacenamiento de Firebase
 * @constant {FirebaseStorage} storage - Almacenamiento de Firebase
 */
export const storage: FirebaseStorage = getStorage(app);

export default app;
